module.exports = __webpack_public_path__ + "static/media/Paynow(White Bg).27a7328f.jpg";